import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ChatbotService } from '#core/services/chatbot.service';
import { ErrorsService } from '#core/services/errors.service';
import { LocalStorage } from '#core/storage/local-storage';
import { environment } from '#environments/environment';
import { LocalStorageKey } from '#shared/enums/local-storage-key';

@Injectable()
export class MyErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly _errorsService: ErrorsService,
        private readonly _chatbotService: ChatbotService,
        private _route: ActivatedRoute,
        private _router: Router
    ) {}

    // Http interceptor to handle errors
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let finalRequest = req;
        // It's important to not send custom headers to others servers to avoid CORS errors
        if (req.url.startsWith(environment.APP_MALOU_API_URL)) {
            finalRequest = req.clone({
                headers: req.headers.set('X-Client-Type', 'web'),
            });
        }

        return next.handle(finalRequest).pipe(
            catchError((err) => {
                if (err.status === 401) {
                    // passport error: only error that does not go in our custom error handler
                    LocalStorage.removeItem(LocalStorageKey.JWT_TOKEN);
                    this._chatbotService.shutdownAndClearSession();

                    if (this._route.snapshot.url?.[0]?.path !== 'login') {
                        this._router.navigate(['auth/login']);
                    }
                } else if (err.status === 403) {
                    if (err.error?.casl) {
                        // WARNING: removing this condition will display unintentional toast of forbiddens for every 403 (like instagram pics). Need to find a better way if you want to do it anyhow
                        this._errorsService.caslForbiddenError$.next(err);
                    } else {
                        this._errorsService.forbiddenError$.next(err);
                    }
                    // passport error: only error that does not go in our custom error handler
                }

                return throwError(() => err);
            })
        );
    }
}
